'use strict';
var parent = require('../../es/instance/splice');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/splice.js
// module id = 770
// module chunks = 13